import Layout from '@/layout';

export default {
  path: '/RTEAO-monitor',
  component: Layout,
  meta: {
    title: 'RTEAO监测',
    icon: 'iconfont icon-home',
    code: '010217',
    activeMenu: '/RTEAO-monitor'
  },
  children: [
    {
      path: '',
      name: 'RTEAOMonitor',
      redirect: { name: 'RTEAOMonitorHome' },
      component: () => import('@/views/RTEAO-Monitor/index.vue'),
      meta: {
        activeMenu: '/RTEAO-monitor',
        noPadding: true
      },
      children: [
        {
          path: 'home',
          name: 'RTEAOMonitorHome',
          component: () => import('@/views/RTEAO-Monitor/home/index.vue'),
          meta: {
            activeMenu: 'RTEAOMonitorHome',
            noPadding: true
          }
        },
        {
          path: 'situation',
          name: 'RTEAOMonitorSituation',
          component: () => import('@/views/RTEAO-Monitor/situation/index.vue'),
          meta: {
            activeMenu: 'RTEAOMonitorSituation',
            noPadding: true
          }
        },
        {
          path: 'ai-training',
          name: 'RTEAOMonitorAITraining',
          component: () => import('@/views/RTEAO-Monitor/AITraining/index.vue'),
          meta: {
            activeMenu: 'RTEAOMonitorAITraining',
            noPadding: true
          }
        },
        {
          path: 'ai-prediction',
          name: 'RTEAOMonitorAIPrediction',
          component: () => import('@/views/RTEAO-Monitor/AIPrediction/index.vue'),
          meta: {
            activeMenu: 'RTEAOMonitorAIPrediction',
            noPadding: true
          }
        },
        {
          path: 'report',
          name: 'RTEAOMonitorReport',
          component: () => import('@/views/RTEAO-Monitor/report/index.vue'),
          meta: {
            activeMenu: 'RTEAOMonitorReport',
            noPadding: true
          }
        },
        {
          path: 'history',
          name: 'RTEAOMonitorHistoryReview',
          component: () => import('@/views/RTEAO-Monitor/historyReview/index.vue'),
          meta: {
            activeMenu: 'RTEAOMonitorHistoryReview',
            noPadding: true
          }
        }
      ]
    },
    {
      path: '*',
      component: () => import('@/views/404')
    }
  ]
};
